export interface ExperienceEntry {
  period: string;
  role: string;
  company: string;
  description: string;
}

// Placeholders — replace period/company with real values before publishing.
export const experience: ExperienceEntry[] = [
  {
    period: "2012 — 2014",
    role: "SOFTWARE ENGINEER",
    company: "Trio Corporation Pvt. Ltd.",
    description: "Building enterprise applications",
  },
  {
    period: "2014 — 2015",
    role: "SENIOR SOFTWARE ENGINEER",
    company: "Trio Corporation Pvt. Ltd.",
    description: "Designing systems and integrations",
  },
  {
    period: "2015 — PRESENT",
    role: "TEAM LEAD",
    company: "Propix Technologies Pvt. Ltd.",
    description: "Leading engineering and architecture",
  },
];
